<template>
  <div class="animated fadeIn">
    <b-row class="mt-4">
      <b-col lg="12">
        <b-row>
          <b-col md="3">
            <span class="tabtext font-weight-bold">Overall Response Rate</span>
          </b-col>
          <b-col md="2">
            <span class="tabtext">{{ OverallResponseRate }}%</span>
          </b-col>
          <b-col md="3">
            <span class="tabtext font-weight-bold">Response Rate (no web)</span>
          </b-col>
          <b-col md="3">
            <span class="tabtext">{{ ResponseRate }}%</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="2">
        <span class="tabtext font-weight-bold">Date</span>
      </b-col>
      <b-col md="1">
        <span class="tabtext font-weight-bold">RSVPs</span>
      </b-col>
      <b-col md="1">
        <span class="tabtext font-weight-bold">Wait</span>
      </b-col>
      <b-col md="1">
        <span class="tabtext font-weight-bold">Total</span>
      </b-col>
      <b-col md="2">
        <span class="tabtext font-weight-bold">Cost</span>
      </b-col>
      <b-col md="2" v-if="!current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">Total % RSVP</span>
      </b-col>
      <!-- <b-col md="2" v-if="!current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">$RSVP</span>
      </b-col> -->
      <b-col md="2" v-if="current_seminar.IsSplit" class="ml-0">
        <span class="tabtext font-weight-bold">% RSVP - Mailer 1</span>
      </b-col>
      <!-- <b-col md="1" v-if="current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">$RSVP-1</span>
      </b-col> -->

      <b-col md="2" v-if="current_seminar.IsSplit" class="ml-0">
        <span class="tabtext font-weight-bold">% RSVP - Mailer 2</span>
      </b-col>
      <!-- <b-col md="1" v-if="current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">$RSVP-2</span>
      </b-col> -->
      <b-col md="1" v-if="current_seminar.IsSplit" class="ml-0">
        <span class="tabtext font-weight-bold">Total% RSVP</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <StatisticsRow
          v-for="seating in current_seminar.Seatings"
          :key="seating.SeatingID"
          :seminar_object="current_seminar"
          :seating_object="seating"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="2">
        <span class="tabtext font-weight-bold"></span>
      </b-col>
      <b-col md="1">
        <span class="tabtext font-weight-bold">{{ TotalRSVPCount }}</span>
      </b-col>
      <b-col md="1">
        <span class="tabtext font-weight-bold">{{ TotalWaitListCount }}</span>
      </b-col>
      <b-col md="1">
        <span class="tabtext font-weight-bold">{{ TotalAttendees }}</span>
      </b-col>
      <b-col md="2">
        <span class="tabtext font-weight-bold">${{ TotalCost }}</span>
      </b-col>
      <b-col md="2" v-if="!current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">{{ ResponseRate }}%</span>
      </b-col>
      <!-- <b-col md="2" v-if="!current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">${{ RSVP_A_Cost }}</span>
      </b-col> -->
      <b-col md="2" v-if="current_seminar.IsSplit" class="ml-0">
        <span class="tabtext font-weight-bold">{{ RSVP_A_Mod }}%</span>
      </b-col>
      <!-- <b-col md="1" v-if="current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">${{RSVP_A_Cost}}</span>
      </b-col> -->

      <b-col md="2" v-if="current_seminar.IsSplit" class="ml-0">
        <span class="tabtext font-weight-bold">{{ RSVP_B_Mod }}%</span>
      </b-col>
      <!-- <b-col md="1" v-if="current_seminar.IsSplit" class="ml-1">
        <span class="tabtext font-weight-bold">${{RSVP_B_Cost}}</span>
      </b-col> -->
      <b-col md="1" v-if="current_seminar.IsSplit" class="ml-0">
        <span class="tabtext font-weight-bold">{{ ResponseRate }}%</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import StatisticsRow from "@/components/CustomSubComponents/StatisticsRow.vue";

export default {
  name: "StatisticsContainer",
  props: {
    seminar_object: { type: Object },
  },
  components: {
    StatisticsRow,
  },
  data() {
    return {
      current_seminar: this.seminar_object,
    };
  },
  computed: {
    SeminarCount() {
      return this.seminar_object.Seatings.length;
    },
    Quantity() {
      return (
        Number(this.seminar_object.Quantity1) +
        Number(this.seminar_object.Quantity2)
      );
    },
    RSVP_A_Cost() {
      var _retObj = 0;
      if (this.TotalRSVPCountA > 0) {
        _retObj = this.current_seminar.Cost1 / this.TotalRSVPCountA;
      }
      return _retObj.toFixed(2);
    },
    RSVP_B_Cost() {
      var _retObj = 0;
      if (this.TotalRSVPCountB > 0) {
        _retObj = this.current_seminar.Cost2 / this.TotalRSVPCountB;
      }
      return _retObj.toFixed(2);
    },
    RSVP_A_Mod() {
      var _retObj = 0;
      if (this.current_seminar.Quantity1 > 0) {
        _retObj = (this.TotalRSVPCountA + this.TotalWaitCountA) / this.current_seminar.Quantity1;
      }
      return (_retObj * 100).toFixed(2);
    },
    RSVP_B_Mod() {
      var _retObj = 0;
      if (this.current_seminar.Quantity2 > 0) {
        _retObj = (this.TotalRSVPCountB + this.TotalWaitCountB) / this.current_seminar.Quantity2;
      }
      return (_retObj * 100).toFixed(2);
    },
    TotalRSVPCountA() {
      var sum = 0;
      this.seminar_object.Seatings.forEach((e) => {
        sum += Number(e.Attendee1Count) //+ Number(e.WaitList1Count);
      });
      return sum;
    },
    TotalRSVPCountB() {
      var sum = 0;
      this.seminar_object.Seatings.forEach((e) => {
        sum += Number(e.Attendee2Count) //+ Number(e.WaitList2Count);
      });
      return sum;
    },
    TotalWaitCountA() {
      var sum = 0;
      this.seminar_object.Seatings.forEach((e) => {
        sum += Number(e.WaitList1Count);
      });
      return sum;
    },
    TotalWaitCountB() {
      var sum = 0;
      this.seminar_object.Seatings.forEach((e) => {
        sum += Number(e.WaitList2Count);
      });
      return sum;
    },
    TotalWaitListCount() {
      return Number(this.TotalWaitCountA) + Number(this.TotalWaitCountB);
    },
    TotalAttendees() {
      return Number(this.TotalWaitListCount) + Number(this.TotalRSVPCount);
    },
    TotalWebCount() {
      var sum = 0;
      this.seminar_object.Seatings.forEach((e) => {
        sum += Number(e.Web1Count);
      });
      return sum;
    },
    TotalRSVPCount() {
      return Number(this.TotalRSVPCountA) + Number(this.TotalRSVPCountB);
    },
    PlusWeb() {
      return Number(this.TotalAttendees) + Number(this.TotalWebCount);
    },
    OverallResponseRate() {
      var sum = 0;
      if (this.Quantity > 0) {
        sum = this.PlusWeb / this.Quantity;
      }
      return (sum * 100).toFixed(2);
    },
    ResponseRate() {
      var sum = 0;
      if (this.Quantity > 0) {
        sum = this.TotalAttendees / this.Quantity;
      }
      return (sum * 100).toFixed(2);
    },
    TotalCost() {
      return (
        (Number(this.current_seminar.Cost1) + Number(this.current_seminar.Cost2)).toFixed(2));
      
    },
  },
};
</script>

<style lang="scss" scoped>
</style>